@if (balance() && currencies().length) {
  <div class="kr-total-balance surface">
    <div class="kr-total-balance__description">
      <h4 class="kr-total-balance__title">
        {{ 'totalBalance.label.totalBalance' | translate }}
        {{ providerType() | providerType }}
      </h4>
      <span
        class="kr-total-balance__value"
        [title]="balance() | balanceFormat: currencySymbol">
        @if (!loading()) {
          {{ balance() | balanceFormat: currencySymbol }}
        }
      </span>
    </div>
    <fu-select
      [labelSize]="'s'"
      class="kr-total-balance__select"
      [formControl]="currencyControl"
      [items]="currencies()" />
  </div>
}
